
import React from "react";
import {
  AddProfileTitle,
  PasswordInputField,
  UpdateButton,
} from ".";
import { Grid } from "@mui/material";
import "../../../Styles/profileDetails.scss";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import security from "../../../Assests/icons/security.png";
import { updateDistributerPassword } from "../../../redux/reducers/profileSettingReducer";
import { useNavigate } from "react-router-dom";


export default function SecurityDetailsForm() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
    } = useForm({
        defaultValues: {
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
        },
    });

    const onSubmit = (data) => {
        if(data.oldPassword === data.newPassword){
            setError("newPassword",{message: "Old password and New password should not be same"});
            return;
        }
        if(data.newPassword !== data.confirmPassword){
            setError("confirmPassword", {message: "Passwords must match with new password"});
            return;
        }
        dispatch(updateDistributerPassword({data, dispatch, setError, navigate}));
    };

    return (
        <div className="addVideo_container">
        <Grid
          container
          spacing={2}
          
        >
            <AddProfileTitle label={"Security Info"} icon1={""} icon2={security} />

            <PasswordInputField
                label="Old Password"
                sizelg={4}
                sizemd={6}
                sizesm={12}
                isRequired={true}
                name="oldPassword"
                register={register}
                errors={errors}
            />
            <PasswordInputField
                label="New Password"
                sizelg={4}
                sizemd={6}
                sizesm={12}
                isRequired={true}
                name="newPassword"
                register={register}
                errors={errors}
            />
            <PasswordInputField
                label="Confirm Password"
                sizelg={4}
                sizemd={6}
                sizesm={12}
                isRequired={true}
                name="confirmPassword"
                register={register}
                errors={errors}
            />

            <UpdateButton label="Update" onClick={handleSubmit(onSubmit)} />
        </Grid>
        </div>
    );
}